import axios from "axios";
import React, { useCallback } from "react";
import { useState } from "react";
import { app_url } from "../../config";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { json, useNavigate } from "react-router-dom";
import Loader from "../../components/Loader";
import Error500 from "../../components/500/Error500";
import debounce from "lodash/debounce";

const AddGlobalPackages = () => {
  const token = JSON.parse(localStorage.getItem("adminEtijwaal"))?.token;
  const [PackageLoader, setPackageLoader] = useState(false);
  const [networkIssue, setNetworkIssue] = useState(false);
  const [PackageDetail, setPackageDetail] = useState(null);
  const [ProviderData, setProviderData] = useState([]);
  const [PackageSec, setPackageSec] = useState(true);
  const [PackageData, setPackageData] = useState([]);
  const [PackageName, setPackageName] = useState("");
  const [ShortInfo, setShortInfo] = useState("");
  const [title, setTitle] = useState("");
  const [Loading, setLoading] = useState(false);
  const [Recharge, setRecharge] = useState(0);
  const [tetherHotspot, setTetherHotspot] = useState(0);
  const [throttle, setThrottle] = useState(0);
  const [Provider, setProvider] = useState("");
  const [CardImg, setCardImg] = useState(null);
  const [partnerCardImg, setPartnerCardImg] = useState(null);
  const [netPrice, setNetPrice] = useState("");
  const [isUnlimited, setIsUnlimited] = useState(0);
  const [Package, setPackage] = useState(""); // selected package id
  const [bgColor, setbgColor] = useState("");
  const [Error, setError] = useState(false);
  const [DataMb, setDataMb] = useState(""); // data field is set from an api
  const [failed, setFailed] = useState("");
  const [Price, setPrice] = useState("");
  const [Day, setDay] = useState("");
  const [info, setInfo] = useState(null);
  const [isKycVerify, setIsKycVerify] = useState(0);
  const [otherInfo, setOtherInfo] = useState(null);
  const [planType, setPlanType] = useState(null);
  const [selectPlanTypeSec, setSelectPlanTypeSec] = useState(true);
  const [selectPlanType, setSelectPlanType] = useState("");
  const [selectPlanTypeData, setSelectPlanTypeData] = useState([]);
  const [selectPlanTypeLoader, setSelectPlanTypeLoader] = useState(false);
  const [voice, setVoice] = useState("");
  const [includeVoice, setIncludeVoice] = useState("");
  const [text, setText] = useState("");
  const [includeText, setIncludeText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [unthrottleData, setUnthrottleData] = useState(null);
  const [throttleSpeed, setThrottlespeed] = useState(null);

  console.log(CardImg, "check CardImg");

  const navigate = useNavigate();
  // console.log(Package, "package check");
  // console.log(planType, "plan type check");

  {
    /* ================= Select Provider =================== */
  }

  const selectprovider = (e) => {
    setDataMb("");
    setVoice("");
    setText("");
    setIncludeVoice("");
    setIncludeText("");
    setPrice("");
    setDay("");
    setNetPrice("");
    setIsUnlimited("");
    setPackageSec(false);
    setPackage("");
    setPackageName("");
    setShortInfo("");
    setTitle("");
    setInfo(null);
    setIsKycVerify(0);
    setOtherInfo(null);
    setPlanType(null);
    setRecharge(0);
    setTetherHotspot(0);
    setThrottle(0);
    setProvider(e.target.value);
    setbgColor("");
    setThrottlespeed("");
    setUnthrottleData("");
  };

  const getPackages = (e, page = 1) => {
    const updatedPlanType = e ? e.target.value : selectPlanType; // Fallback to existing planType if e is null
    setSelectPlanType(updatedPlanType); // state update with the new value
    setPackage("");
    setPackageLoader(true);
    setPackageSec(true);
    setDataMb("");
    setVoice("");
    setText("");
    setIncludeVoice("");
    setIncludeText("");
    setDay("");
    setPrice("");
    setNetPrice("");
    setIsUnlimited("");
    setPackageName("");
    setShortInfo("");
    setTitle("");
    setbgColor("");
    // setCardImg(null);
    setInfo(null);
    setIsKycVerify(0);
    setOtherInfo(null);
    setPlanType(null);
    setRecharge(0);
    setTetherHotspot(0);
    setThrottle(0);
    setThrottlespeed(null);
    setUnthrottleData(null);
    {
      /* ================= Package Api =================== */
    }
    axios
      .get(
        `${app_url}/api/package/getPackagesFromCarrierProvider?carrierProviderId=${Provider}&countryCode=&slug=global&plan_type=${updatedPlanType}&page=${page}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (page === 1) {
          setPackageData(res.data.packages);
        } else {
          setPackageData((prevData) => [...prevData, ...res.data.packages]);
        }
        setRecharge(res?.data?.rechargeability);
        setInfo(res?.data?.info);
        setIsKycVerify(res?.data?.is_kyc_verify);
        setOtherInfo(res?.data?.other_info);
        setPlanType(res?.data?.plan_type);
        setPackageSec(false);
        setPackageLoader(false);

        // Storing lastPage and current page in the state
        setLastPage(res?.data?.meta?.lastPage);
        setCurrentPage(page);
      })
      // .catch((err) => {
      //   if (err.response?.status === 401) {
      //     navigate("/");
      //   } else if (err.response?.status === 400) {
      //     toast.error(err.response?.data.message);
      //   } else {
      //     setNetworkIssue(true);
      //     setFailed(err.message);
      //   }
      // });
      .catch((err) => {
        setLoading(false);
        if (err.response) {
          if (err.response.status === 400) {
            toast.error(err.response.data.message || "Bad Request");
          } else if (err.response.status === 401) {
            navigate("/");
          } else if (err.response.status === 500) {
            toast.error(err.response.data.message || "Internal Server Error");
          } else {
            toast.error("An unexpected error occurred.");
          }
        } else {
          setNetworkIssue(true);
          toast.error("Network error. Please check your internet connection.");
          setFailed("Network error. Please check your internet connection.");
        }
      });
  };

  const getPlanType = (e) => {
    setPackageSec(true);
    setPackage("");
    setSelectPlanType("");
    setPackageData([]);
    setSelectPlanTypeData([]);
    setSelectPlanTypeLoader(true);
    setSelectPlanTypeSec(true);
    {
      /* ================= Paln Type Api =================== */
    }
    axios
      .get(
        `${app_url}/api/package/getPlanTypeFromCarrierProviderAndSlug?carrierProviderId=${Provider}&slug=global&countryCode=&regionSlug=`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setSelectPlanTypeData(res);
        setSelectPlanTypeLoader(false);
        setSelectPlanTypeSec(false);
      })
      .catch((err) => {
        setSelectPlanTypeLoader(false);
        if (err.response) {
          if (err.response.status === 400) {
            toast.error(err.response.data.message || "Bad Request");
          } else if (err.response.status === 401) {
            navigate("/");
          } else if (err.response.status === 500) {
            toast.error(err.response.data.message || "Internal Server Error");
          } else {
            toast.error("An unexpected error occurred.");
          }
        } else {
          setNetworkIssue(true);
          toast.error("Network error. Please check your internet connection.");
          setFailed("Network error. Please check your internet connection.");
        }
      });
  };

  useEffect(() => {
    if (Provider) {
      getPlanType();
    }
  }, [Provider]);

  const handleSelectChange = (e) => {
    const selectedValue = e.target.value;

    // Check if "See More" is selected
    if (selectedValue === "seeMore") {
      if (currentPage < lastPage) {
        getPackages(null, currentPage + 1);
        // console.log("Fetching more packages...");
      }
    } else {
      // Handle other selections
      selectPackage(e);
    }
  };

  // console.log("CardImg *********", CardImg);

  {
    /* ================= Select Package =================== */
  }
  const selectPackage = (e) => {
    setPackage(e.target.value);
    const desiredObject = PackageData?.find(
      (item) => item.id === e.target.value
    );
    if (desiredObject) {
      console.log(desiredObject, "desired boject");
      setDataMb(desiredObject.data);
      setVoice(desiredObject.voice);
      setIncludeVoice(desiredObject.includeVoice);
      setText(desiredObject.text);
      setIncludeText(desiredObject.includeText);
      setPrice(desiredObject.price);
      setNetPrice(desiredObject.net_price);
      setIsUnlimited(desiredObject.is_unlimited);
      setDay(desiredObject.day);
      setPackageDetail(desiredObject);
      setThrottlespeed(desiredObject.throttle_speed);
      setUnthrottleData(desiredObject.unthrottle_data);
      setTetherHotspot(desiredObject.tether_hotspot);
      setThrottle(desiredObject.throttle);
      setTitle(desiredObject.title);
    }
  };

  {
    /* ================= Provider Api =================== */
  }
  useEffect(() => {
    axios
      .get(`${app_url}/api/package/getAllActiveCarrierProvider`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setProviderData(res);
      })
      .catch((err) => {
        if (err.response) {
          if (err.response.status === 400) {
            toast.error(err.response.data.message || "Bad Request");
          } else if (err.response.status === 401) {
            navigate("/");
          } else if (err.response.status === 500) {
            toast.error(err.response.data.message || "Internal Server Error");
          } else {
            toast.error("An unexpected error occurred.");
          }
        } else {
          setNetworkIssue(true);
          toast.error("Network error. Please check your internet connection.");
          setFailed("Network error. Please check your internet connection.");
        }
      });
  }, []);

  const [results, setResults] = useState(null);

  const fetchPackages = async (name) => {
    try {
      const response = await axios.get(
        `${app_url}/api/package/searchActiveAndNonExpiredPackageNameByPackageName?packageName=${name}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setResults(response?.data?.available);
      setError("");
      // console.log(response?.data);
    } catch (err) {
      if (err.response) {
        if (err.response.status === 400) {
          toast.error(err.response.data.message || "Bad Request");
        } else if (err.response.status === 401) {
          navigate("/");
        } else if (err.response.status === 500) {
          toast.error(err.response.data.message || "Internal Server Error");
        } else {
          toast.error("An unexpected error occurred.");
        }
      } else {
        setNetworkIssue(true);
        toast.error("Network error. Please check your internet connection.");
        setFailed("Network error. Please check your internet connection.");
      }
    }
  };

  const debouncedFetchPackages = useCallback(debounce(fetchPackages, 500), []);

  useEffect(() => {
    if (PackageName.length >= 10) {
      debouncedFetchPackages(PackageName);
    }
  }, [PackageName, debouncedFetchPackages]);

  const handlePackageNameChange = (e) => {
    const value = e.target.value.replace(/\s/g, "");
    setPackageName(value);
    if (!value) {
      setError("Enter Package Name *");
    } else {
      setError("");
    }
  };

  const AddPackage = (e) => {
    e.preventDefault();
    if (
      PackageName === "" ||
      Provider === "" ||
      Package === "" ||
      !PackageDetail?.title ||
      !PackageDetail?.data ||
      !PackageDetail?.amount ||
      !Price ||
      !PackageDetail?.day ||
      !PackageDetail?.net_price ||
      ShortInfo === "" ||
      title === "" ||
      bgColor === "" ||
      CardImg === null ||
      CardImg?.size > 30000 ||
      partnerCardImg === null ||
      partnerCardImg?.size > 30000
    ) {
      setError(true);
    } else {
      setLoading(true);
      const formData = new FormData();
      // Append data to the FormData object
      formData.append("packageName", PackageName);
      formData.append("carrierProviderId", Provider);
      formData.append("carrierPackageId", Package);
      formData.append("includeData", PackageDetail?.data);
      formData.append("dataMB", PackageDetail?.amount);
      formData.append("includeVoice", PackageDetail?.includeVoice);
      formData.append("voice", PackageDetail?.voice);
      formData.append("includeText", PackageDetail?.includeText);
      formData.append("text", PackageDetail?.text);
      formData.append("price", Price);
      formData.append("day", PackageDetail?.day);
      formData.append("type", "global");
      formData.append("shortInfo", ShortInfo);
      formData.append("title", title);
      formData.append("rechargeability", Recharge);
      formData.append("packageCardColor", bgColor);
      formData.append("cardImage", CardImg);
      formData.append("cardImage_partner", partnerCardImg);
      formData.append("netPrice", PackageDetail?.net_price);
      formData.append("is_kyc_verify", isKycVerify);
      formData.append("throttle_speed", PackageDetail?.throttle_speed);
      formData.append("unthrottle_data", PackageDetail?.unthrottle_data);
      formData.append("tether_hotspot", PackageDetail?.tether_hotspot);
      formData.append("throttle", PackageDetail?.throttle);
      formData.append(
        "package_info",
        info && info[0] !== "" ? JSON.stringify(info) : null
      );
      formData.append(
        "other_info",
        otherInfo ? otherInfo : PackageDetail?.short_info
      );
      formData.append("plan_type", planType);
      formData.append(
        "is_unlimited",
        PackageDetail?.is_unlimited === false ? 0 : 1
      );
      axios
        .post(`${app_url}/api/package/registerNewPackage`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setProvider("");
          setPackage("");
          setPackageName("");
          setShortInfo("");
          setTitle("");
          setbgColor("");
          setDataMb("");
          setVoice("");
          setText("");
          setIncludeVoice("");
          setThrottlespeed(null);
          setUnthrottleData(null);
          setTetherHotspot(0);
          setThrottle(0);
          setIncludeText("");
          setPrice("");
          setDay("");
          setNetPrice("");
          setIsUnlimited("");
          setCardImg(null);
          setPartnerCardImg(null);
          setLoading(false);
          setError(false);
          setPackageSec(true);
          setInfo(null);
          setIsKycVerify(0);
          setOtherInfo(null);
          setPlanType(null);
          setRecharge(0);
          toast.success(res.data.message);
          setTimeout(() => {
            window.location.reload();
          }, [500]);
        })
        .catch((err) => {
          setLoading(false);
          if (err.response) {
            if (err.response.status === 400) {
              toast.error(err.response.data.message || "Bad Request");
            } else if (err.response.status === 401) {
              navigate("/");
            } else if (err.response.status === 500) {
              toast.error(err.response.data.message || "Internal Server Error");
            } else {
              toast.error("An unexpected error occurred.");
            }
          } else {
            setNetworkIssue(true);
            toast.error(
              "Network error. Please check your internet connection."
            );
            setFailed("Network error. Please check your internet connection.");
          }
        });
    }
  };

  if (networkIssue) {
    return <Error500 message={failed} />;
  }

  return (
    <>
      <section className="wrapper">
        <p className="heading">
          <i
            className="bi bi-arrow-left-circle-fill fs-3 me-3 my-auto pointer"
            onClick={() => window.history.back()}
          ></i>
          Add Global Package
        </p>
        <div className="card">
          <div className="card-body">
            <form action="" onSubmit={AddPackage}>
              <div className="row add-pkg-form">
                {/* ================= Select Provider =================== */}
                <div className="col-md-4 col-sm-6">
                  <label htmlFor="">Select Provider</label>
                  <select
                    className="form-select"
                    value={Provider}
                    onChange={selectprovider}
                  >
                    <>
                      <option value="" hidden>
                        Provider
                      </option>
                      {ProviderData?.data?.carriers?.map((item, index) => (
                        <option value={item.id} key={index}>
                          {" "}
                          {item.carrierName} ({item.provider}-{item.environment}
                          )
                        </option>
                      ))}
                    </>
                  </select>
                  {Error ? (
                    <small className="text-red">
                      {Provider === "" ? "Select Provider *" : ""}
                    </small>
                  ) : (
                    ""
                  )}
                </div>

                {/* ================= Select Plan Type =================== */}
                <div className="col-md-4 col-sm-6">
                  <label htmlFor="">Select Plan Type</label>
                  <select
                    className="form-select"
                    value={selectPlanType}
                    onChange={(e) => getPackages(e)}
                    disabled={selectPlanTypeSec}
                  >
                    {selectPlanTypeLoader ? (
                      <option value="" hidden>
                        ...loading
                      </option>
                    ) : (
                      <>
                        <option value="" hidden>
                          Plan Type
                        </option>
                        {selectPlanTypeData?.data?.plans?.length === 0 && (
                          <option value="" disabled>
                            No Plan Type Found
                          </option>
                        )}
                        {selectPlanTypeData?.data?.plans?.map((item, index) => (
                          <option key={index} value={item.op_id}>
                            {item.type}
                          </option>
                        ))}
                      </>
                    )}
                  </select>
                  {Error ? (
                    <small className="text-red">
                      {selectPlanType === "" ? "Select Plan Type *" : ""}
                    </small>
                  ) : (
                    ""
                  )}
                </div>

                {/* ================= Select Package =================== */}
                <div className="col-md-4 col-sm-6">
                  <label htmlFor="">Select Package</label>
                  <select
                    className="form-select"
                    value={Package}
                    // onChange={selectPackage}
                    onChange={handleSelectChange}
                    disabled={PackageSec}
                  >
                    {PackageLoader && (
                      <option value="" hidden>
                        ...loading
                      </option>
                    )}
                    <option value="" hidden>
                      Package
                    </option>
                    {PackageData?.length === 0 && (
                      <option value="" disabled>
                        {" "}
                        No Packages Found{" "}
                      </option>
                    )}
                    {PackageData?.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                    {currentPage < lastPage && (
                      <option value="seeMore" className="text-primary">
                        See More
                      </option>
                    )}
                  </select>
                  {Error ? (
                    <small className="text-red">
                      {Package === "" ? "Select Package *" : ""}
                    </small>
                  ) : (
                    ""
                  )}
                </div>
                <hr className="sm:my-5 my-3" />

                {/* ================= Data Display =================== */}
                <div className="col-md-3 col-sm-6">
                  <label htmlFor="">Data:</label>
                  <input
                    type="text"
                    disabled
                    name=""
                    placeholder="Ex: 10 MB"
                    id=""
                    value={DataMb === null ? "0 GB" : DataMb}
                    className="form-control"
                  />
                  {Error ? (
                    <small className="text-red">
                      {DataMb === "" ? "Select Package *" : ""}
                    </small>
                  ) : (
                    ""
                  )}
                </div>

                {/* ================= Voice Display =================== */}
                <div className="col-md-3 col-sm-6">
                  <label htmlFor="">Voice:</label>
                  <input
                    type="text"
                    disabled
                    name=""
                    placeholder="Ex: 10 Minutes"
                    id=""
                    value={includeVoice === null ? "0 Minute" : includeVoice}
                    className="form-control"
                  />
                  {Error ? (
                    <small className="text-red">
                      {includeVoice === "" ? "Select Package *" : ""}
                    </small>
                  ) : (
                    ""
                  )}
                </div>

                {/* ================= Text Display =================== */}
                <div className="col-md-3 col-sm-6">
                  <label htmlFor="">Text:</label>
                  <input
                    type="text"
                    disabled
                    name=""
                    placeholder="Ex: 10 SMS"
                    id=""
                    value={includeText === null ? "0 SMS" : includeText}
                    className="form-control"
                  />
                  {Error ? (
                    <small className="text-red">
                      {includeText === "" ? "Select Package *" : ""}
                    </small>
                  ) : (
                    ""
                  )}
                </div>

                {/* ================= Day Display =================== */}
                <div className="col-md-3 col-sm-6">
                  <label htmlFor="">Day:</label>
                  <input
                    type="text"
                    disabled
                    name=""
                    id=""
                    placeholder="Ex: 10 Days "
                    value={Day}
                    className="form-control"
                  />
                  {Error ? (
                    <small className="text-red">
                      {Day === "" ? "Select Package *" : ""}
                    </small>
                  ) : (
                    ""
                  )}
                </div>

                {/* isUnlimited */}
                <div className="col-md-3 col-sm-6">
                  <label htmlFor="">Unlimited</label>
                  {isUnlimited.length !== 0 && (
                    <input
                      type="text"
                      disabled
                      name=""
                      id=""
                      placeholder="Ex: Yes or No"
                      value={isUnlimited === true ? "Yes" : "No"}
                      className="form-control"
                    />
                  )}
                  {isUnlimited.length === 0 && (
                    <input
                      type="text"
                      disabled
                      name=""
                      id=""
                      placeholder="Ex: Yes or No"
                      value={isUnlimited}
                      className="form-control"
                    />
                  )}
                  {Error ? (
                    <small className="text-red">
                      {Day === "" ? "Select Package *" : ""}
                    </small>
                  ) : (
                    ""
                  )}
                </div>

                {/* Net Price */}
                <div className="col-md-3 col-sm-6">
                  <label htmlFor="">Net Price: (US$)</label>
                  <input
                    type="text"
                    disabled
                    name=""
                    id=""
                    placeholder="Ex: 10 $ "
                    value={netPrice}
                    className="form-control"
                  />
                  {Error ? (
                    <small className="text-red">
                      {Day === "" ? "Select Package *" : ""}
                    </small>
                  ) : (
                    ""
                  )}
                </div>

                {/* ================= Price Display =================== */}
                <div className="col-md-3 col-sm-6">
                  <label htmlFor="">Sale Price: (US$)</label>
                  <input
                    type="text"
                    name=""
                    placeholder="Ex: 10 $ "
                    id=""
                    value={Price}
                    onChange={(e) => {
                      let pattern = /^(\d*\.?\d*)?$/;
                      const val = e.target.value;
                      if (!pattern.test(val)) return;
                      setPrice(e.target.value);
                    }}
                    className="form-control"
                  />
                  {Error ? (
                    <small className="text-red">
                      {Price === "" ? "Select Package *" : ""}
                    </small>
                  ) : (
                    ""
                  )}
                </div>

                <hr className="sm:my-5 my-3" />

                {/* ================= Package Name =================== */}
                <div className="col-md-3 col-sm-6">
                  <label htmlFor="packageName">Package Name:</label>
                  <div className="max-Alphabet-p">
                    <input
                      type="text"
                      id="packageName"
                      placeholder="Ex: UAE-7days-1gb"
                      value={PackageName}
                      onChange={handlePackageNameChange}
                      maxLength={30}
                      className="form-control"
                    />
                    <div className="max-Alphabet">
                      {PackageName.length} / 30
                    </div>
                  </div>
                  {Error && <small className="text-red">{Error}</small>}
                  {PackageName.length == 0 ? (
                    ""
                  ) : PackageName.length < 10 ? (
                    <div className="">
                      {/* <pre>{JSON.stringify(results, null, 2)}</pre> */}
                      <p className="text-danger mt-2">
                        Can't check availaibility
                      </p>
                    </div>
                  ) : results == true ? (
                    <div className="">
                      {/* <pre>{JSON.stringify(results, null, 2)}</pre> */}
                      <p className="text-success mt-2">
                        ({PackageName}) slot is available
                      </p>
                    </div>
                  ) : (
                    <div className="">
                      {/* <pre>{JSON.stringify(results, null, 2)}</pre> */}
                      <p className="text-danger mt-2">
                        This package ({PackageName}) already exist in our system
                      </p>
                    </div>
                  )}
                  {Error ? (
                    <small className="text-red">
                      {PackageName === "" ? "Enter Package Name *" : ""}
                    </small>
                  ) : (
                    ""
                  )}
                </div>
                {/* ================= Title =================== */}
                <div className="col-md-3 col-sm-6">
                  <label htmlFor="">Title:</label>
                  <div className="max-Alphabet-p">
                    <textarea
                      type="text"
                      value={title}
                      maxLength={100}
                      onChange={(e) => setTitle(e.target.value)}
                      placeholder="Ex:20 GB - 30 Days"
                      className="form-control"
                      name=""
                      id=""
                      // style={{ resize: "none" }}
                      style={{ height: "3.4em" }}
                    />
                    <div className="max-Alphabet">{title?.length} / 100</div>
                  </div>
                  {Error ? (
                    <small className="text-red">
                      {title === "" ? "Enter Title *" : ""}
                    </small>
                  ) : (
                    ""
                  )}
                </div>

                {/* ================= Short Info =================== */}
                <div className="col-md-3 col-sm-6">
                  <label htmlFor="">Short Info:</label>
                  <div className="max-Alphabet-p">
                    <input
                      type="text"
                      value={ShortInfo}
                      maxLength={20}
                      onChange={(e) => setShortInfo(e.target.value)}
                      placeholder="Ex:United-Arab-Emirates"
                      className="form-control"
                      name=""
                      id=""
                    />
                    <div className="max-Alphabet">{ShortInfo.length} / 20</div>
                  </div>
                  {Error ? (
                    <small className="text-red">
                      {ShortInfo === "" ? "Enter Short Info *" : ""}
                    </small>
                  ) : (
                    ""
                  )}
                </div>

                {/* ================= Select Background Color =================== */}
                <div className="col-md-3 col-sm-6">
                  <label htmlFor="">Select Background Color</label>
                  <div class="input-group">
                    <select
                      name=""
                      onChange={(e) => setbgColor(e.target.value)}
                      id=""
                      className="form-select pe-4"
                    >
                      <option value="" hidden>
                        Background Colour
                      </option>
                      <option value="#28282B">Matte Black </option>
                      <option value="#FF5733">Orange</option>
                      <option value="#363062">Purple</option>
                      <option value="#525FE1">Violet</option>
                      <option value="#F9B572">Sand</option>
                      <option value="#025464">Cyan</option>
                      <option value="#47A992">Sea Green</option>
                      <option value="#146C94">Eminent Blue</option>
                      <option value="#19A7CE">Sky Blue</option>
                      <option value="#F45050">Soft Red</option>
                      <option value="#FFD24C">Yellow</option>
                      <option value="#388E3C">Green</option>
                      <option value="#4D606E">Grey</option>
                    </select>
                    <span className="input-group-text" id="basic-addon1">
                      <input
                        type="color"
                        value={bgColor}
                        className="type-clr"
                        name=""
                        id=""
                      />
                    </span>
                  </div>
                  {Error ? (
                    <small className="text-red">
                      {bgColor === "" ? "Select Background Colour *" : ""}
                    </small>
                  ) : (
                    ""
                  )}
                </div>

                {/* ================= Select Card Image =================== */}
                <div className="col-md-3 col-sm-6">
                  <label htmlFor="">Select Card Image</label>
                  <input
                    type="file"
                    placeholder="United-Arab-Emirates"
                    className="form-control"
                    name=""
                    accept="image/png"
                    onChange={(e) => {
                      setCardImg(e.target.files[0]);
                    }}
                    id=""
                  />
                  {Error ? (
                    <small className="text-red">
                      {CardImg === null
                        ? "Select Card Image *"
                        : CardImg?.size > 30000
                        ? "Image Size Should be Less Then 30kb *"
                        : CardImg === ""
                        ? "Select Card Image *"
                        : ""}
                    </small>
                  ) : (
                    ""
                  )}
                  <ul className="img-bullit ps-4 ">
                    <li>Image Size Should be Less Then 30kb</li>
                    <li>Image Resolution Should be 380 x 240 (Recommended)</li>
                  </ul>
                </div>

                {/* ================= Select Partner's Card Image =================== */}
                <div className="col-md-3 col-sm-6">
                  <label htmlFor="">Select Partner's Card Image</label>
                  <input
                    type="file"
                    placeholder="United-Arab-Emirates"
                    className="form-control"
                    name=""
                    accept="image/png"
                    onChange={(e) => {
                      setPartnerCardImg(e.target.files[0]);
                    }}
                    id=""
                  />
                  {Error ? (
                    <small className="text-red">
                      {partnerCardImg === null
                        ? "Select Card Image *"
                        : partnerCardImg?.size > 30000
                        ? "Image Size Should be Less Then 30kb *"
                        : partnerCardImg === ""
                        ? "Select Card Image *"
                        : ""}
                    </small>
                  ) : (
                    ""
                  )}
                  <ul className="img-bullit ps-4 ">
                    <li>Image Size Should be Less Then 30kb</li>
                    <li>Image Resolution Should be 380 x 240 (Recommended)</li>
                  </ul>
                </div>

                <hr className="sm:my-5 my-3" />
                {info && info[0] !== "" ? (
                  <div className="col-md-3 col-sm-6">
                    <h5 htmlFor="">Package Information</h5>
                    <ul className="ps-0">
                      {info.map((item, index) => (
                        <li key={index} style={{ listStyle: "none" }}>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  ""
                )}

                {otherInfo || PackageDetail?.short_info ? (
                  <div className="col-md-3 col-sm-6">
                    <div>
                      <h5>Other Information</h5>
                      <p>{otherInfo ? otherInfo : PackageDetail?.short_info}</p>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                {/* ================= Select Background Color =================== */}
                {planType ? (
                  <div className="col-md-3 col-sm-6">
                    <div>
                      <h5>Plan Type</h5>
                      <p>{planType}</p>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div className="col-md-3 col-sm-6">
                  <div>
                    <h6>
                      KYC Verification:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {isKycVerify === 0 ? "NO" : "YES"}
                      </span>
                    </h6>
                    <h6>
                      Rechargeability:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {Recharge === 0 ? "NO" : "YES"}
                      </span>
                    </h6>
                  </div>
                </div>

                {unthrottleData || throttleSpeed ? (
                  <div className="col-md-3 col-sm-6">
                    <div>
                      {unthrottleData && (
                        <h6>
                          Unthrottle Data:{" "}
                          <span style={{ fontWeight: "lighter" }}>
                            {unthrottleData}
                          </span>
                        </h6>
                      )}
                      {throttleSpeed && (
                        <h6>
                          Throttle Speed:{" "}
                          <span style={{ fontWeight: "lighter" }}>
                            {throttleSpeed}
                          </span>
                        </h6>
                      )}
                    </div>
                  </div>
                ) : (
                  ""
                )}

                <div className="col-md-3 col-sm-6">
                  <div>
                    <h6>
                      Tether Hotspot:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {tetherHotspot === 0 ? "NO" : "YES"}
                      </span>
                    </h6>
                    <h6>
                      Throttle:{" "}
                      <span style={{ fontWeight: "lighter" }}>
                        {throttle === 0 ? "NO" : "YES"}
                      </span>
                    </h6>
                  </div>
                </div>
                <hr className="sm:my-5 my-3" />

                {/* ================= Form Submit =================== */}
                <div className="d-flex justify-content-center ">
                  <button
                    className="btn primary-btn w-50 py-2 d-flex align-items-center justify-content-center gap-2"
                    type="submit"
                  >
                    <span className="text-white fs-5">Submit</span>
                    {Loading ? (
                      <>
                        <div
                          className="text-white spinner-border"
                          role="status"
                        >
                          <span className="visually-hidden">Loading..</span>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default AddGlobalPackages;
